forgetCache